import { createLocalizationProvider } from '@atlaskit/locale';
export var formatterOptions = {
  day: '2-digit',
  month: 'short',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  hour12: true
};
export var partsFormatter = function partsFormatter(_ref) {
  var day = _ref.day,
    month = _ref.month,
    year = _ref.year,
    hour = _ref.hour,
    minute = _ref.minute,
    _ref$dayPeriod = _ref.dayPeriod,
    dayPeriod = _ref$dayPeriod === void 0 ? '' : _ref$dayPeriod;
  var formattedDayPeriod = dayPeriod.replace(/\./g, '').replace(/\s/g, '');
  return "".concat(day, " ").concat(month, " ").concat(year, ", ").concat(hour, ":").concat(minute, " ").concat(formattedDayPeriod);
};
export var formatDate = function formatDate(timestamp) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';
  var l10n = createLocalizationProvider(locale, formatterOptions);
  return partsFormatter(l10n.formatToParts(timestamp));
};